import React from 'react';
import ReactLoading from 'react-loading';

export default function Loading() {

/* types para el ReactLoading
balls
bars
bubbles
cubes
cylon
spin
spinningBubbles
spokes
*/

const DivLoading = () => (
        <ReactLoading type={'spokes'} color={'#435363'} height={357} width={65} />
);
 return(
    <div className="divLoading">
        <div className="divLoadingImg"><DivLoading /></div>
    </div>
  );
} 